import * as swcHelpers from '@swc/helpers';
import { isLineItemReorderable } from '../../utils/is-line-item-reorderable.js';
import { createLineItemId } from '../view/utils/create-line-item-id.js';
import { isContactLensesOrderLineItem } from '../view/utils/order-line-item-product-type-guards.js';

const convertLineItemToDraft = (orderLineItem)=>{
    const draft = {
        quantity: orderLineItem.quantity,
        sku: orderLineItem.product.sku,
        type: 'regular'
    };
    if (isContactLensesOrderLineItem(orderLineItem)) {
        return swcHelpers.objectSpread({}, draft, {
            type: 'contact-lenses',
            typeDetails: {
                // eyeSide is changed to lowerCase because this is the format that the backend accepts
                eyeSide: orderLineItem.eyeSide.toLocaleLowerCase()
            }
        });
    }
    return draft;
};
const toDrafts = (orderLineItems)=>{
    if (!orderLineItems) {
        return {};
    }
    return Object.fromEntries(orderLineItems.filter(isLineItemReorderable).map((lineItem)=>[
            createLineItemId(lineItem),
            convertLineItemToDraft(lineItem)
        ]
    ));
};

export { toDrafts };
//# sourceMappingURL=to-drafts.js.map
